<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <h1 class="vtz-h1" id="main-title" i18n>Results</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        <!-- What is your level of satisfaction with the mobile voting pilot? (5 is very satisfied) -->
        {{statementResults?.statementDescription}}
      </p>
      <div class="chart-container">
        <h2 class="vtz-h2 vtz-text--center" i18n>
          Total Votes: {{total}}
        </h2>
        <!-- Other color schemes: 'vivid' or 'neons' -->
        <ngx-charts-pie-chart
          [scheme]="'picnic'"
          [results]="data"
          [legend]="legend"
          [legendPosition]="legendPosition"
          [labels]="labels"
          [labelFormatting]="formatLabel"
          [doughnut]="doughnut"
          [arcWidth]="arcWidth"
          [animations]="animations"
          [tooltipDisabled]="tooltipDisabled"
          [tooltipText]="formatTooltip">
        </ngx-charts-pie-chart>
      </div>
      <div id="vtz-actions" class="vtz-actions">
        <div id="button-group" class="dialog-button-container">
          <button id="back-to-contest-list" class="button-primary" (click)="backToContestList()" i18n="Button label">
            BACK TO LIST
          </button>
          @if(currentIndex > 0) {
            <button id="back-to-contest-list" class="button-primary" (click)="previous()" i18n="Button label">
              PREVIOUS
            </button>
          }
          @if(currentIndex < numStatements-1) {         
             <button id="back-to-contest-list" class="button-primary" (click)="next()" i18n="Button label">
              NEXT
            </button>
          }
        </div>
      </div>
    </main>
  </div>
</div>